import { render, staticRenderFns } from "./ConfirmThirdPartyModal.vue?vue&type=template&id=52c2dcca&"
import script from "./ConfirmThirdPartyModal.vue?vue&type=script&lang=js&"
export * from "./ConfirmThirdPartyModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports